import Axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'

import router from '@/router'
import {
  getAccessToken,
  hasTokenSaved,
  remove,
  getRefreshUrl,
  renewAccessToken,
} from '@/util/token'

const AUTH_API_URL = process.env.VUE_APP_AUTH_API_URL_BASE
const http = Axios.create({
  baseURL: process.env.VUE_APP_API_URL_BASE,
})

function reAuth(failedRequest) {
  return renewAccessToken().then(() => {
    const token = getAccessToken()
    failedRequest.response.config.headers['Authorization'] = `Bearer ${token}`
    return Promise.resolve()
  })
}

createAuthRefreshInterceptor(http, reAuth)

http.interceptors.request.use(async config => {
  if (!hasTokenSaved()) {
    return config
  }

  // トークンの提示が必要ないエンドポイントもあるが、ひとまず
  // クライアントにトークンが保存されていればそれを送る。
  let token = getAccessToken()

  if (!token) {
    return config
  }

  if (AUTH_API_URL) {
    config.headers.Authorization = `Bearer ${token}`
  } else {
    // APIゲートウェイをバイパスする場合、認証情報をAuthorizationヘッダー
    // で送るのではなく、`X-Apigateway-Api-Userinfo`にBase64エンコード
    // したユーザー情報を送ります。
    config.headers['X-Apigateway-Api-Userinfo'] = token
  }

  return config
})

http.interceptors.response.use(
  r => {
    // NOP
    return r
  },
  error => {
    if (error.response.config.url === getRefreshUrl()) {
      // トークンリフレッシュの失敗はもうどうしようもないのでログイン画面に移す
      remove()
      router.push('/login')
    }

    return Promise.reject(error)
  },
)

export default http
